<template>
  <div class="device">
    <!-- 老版设备管理 -->
    <div class="devicetop">
      <!-- <div class="devicename">{{$t('device.deviceList')}}</div> -->
      <ul class="status-container">
        <li v-for="(value,key) in deviceStatus" :key="key" class="status">
          <span class="status-label">
            <i class="status-icon" :class="value.class"></i>
            {{value.label + ' : '}}
          </span>
          <span class="status-num">{{value.num}}</span>
        </li>
      </ul>
    </div>
    <div class="search">
      <div class="searchLeft">
        <el-select
          v-model="search.status"
          clearable
          @change="getDeviceList(true)"
          :placeholder="$t('device.device_status')"
          popper-class="select-search"
        >
          <el-option
            v-for="(value,key) in $filter.deviceStatus"
            :key="key"
            :value="key"
            :label="value.label"
            style="display:flex;padding-left:40px;align-items:center;"
          >
            <i style="width:10px;height:10px;margin-right:8px;" :class="`status-${value.name}`"></i>
            <span class="select-label">{{value.label}}</span>
          </el-option>
        </el-select>
        <el-select
          v-model="search.brand"
          clearable
          @change="getDeviceList(true)"
          :placeholder="$t('device.device_type')"
          popper-class="select-search"
        >
          <el-option
            v-for="item in $filter.deviceType"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-input
          v-model="search.usr"
          clearable
          @keyup.enter.native="getDeviceList(true)"
          :placeholder="$t('device.User_belong')"
          popper-class="select-search"
        ></el-input>
        <el-input
          v-model.trim="search.pn"
          @keyup.enter.native="getDeviceList(true)"
          :placeholder="this.$t('device.datalogger_pn')"
          clearable
        ></el-input>
         <el-input
          v-model.trim="search.search"
          @keyup.enter.native="getDeviceList(true)"
          :placeholder="this.$t('device.Sn_deviceName')"
          clearable
        ></el-input>
        <button class="button-solid button" @click="getDeviceList(true)"><i class="el-icon-search"></i></button>
      </div>
      <div class="searchRight">
        <button
          v-if="this.$store.state.user.role ==1"
          class="button-solid button"
          @click="editDeviceControl"
        >{{$t('device.edit_control')}}</button>
      </div>
    </div>
    <div class="sections">
      <!-- <div class="title">{{$t('device.deviceList')}}</div> -->
      <div class="table">
        <el-table
          :data="deviceList"
          border
          stripe
          height="100%"
          :row-style="{height:0}"
          :cell-style="{padding:0}"
          :header-cell-style="{background:'#F2F5F7',color:'#606266'}"
          :empty-text="$t('message.nodata')"
          v-loading="loadingDevice"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            fixed
            min-width="110px;"
            :label="$t('device.device_name')"
          >
            <template slot-scope="scope">
              <span
                class="redirect"
                @click="enterDevice(scope.row)"
                :title="scope.row.devalias||scope.row.sn"
              >{{scope.row.devalias||scope.row.sn}}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="100px;"
            :show-overflow-tooltip="true"
            :label="$t('device.device_sn')"
          >
            <template slot-scope="scope">
              <span :title="scope.row.sn||'--'">{{scope.row.sn||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            min-width="120px;"
            :show-overflow-tooltip="true"
            :label="$t('device.device_status')"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.status!==undefined"
                :class="`color-${$filter.deviceStatus[scope.row.status].name}`"
              >{{$filter.deviceStatus[scope.row.status].label}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="brand"
            :show-overflow-tooltip="true"
            :label="$t('device.device_type')"
          >
            <template slot-scope="scope">
              {{scope.row.brand | translateDeviceType}}
            </template>
          </el-table-column>-->
          <el-table-column
            prop="devcode"
            min-width="90px;"
            :show-overflow-tooltip="true"
            :label="$t('device.device_code')"
          ></el-table-column>
          <el-table-column
            prop="pn"
            min-width="135px;"
            :show-overflow-tooltip="true"
            :label="$t('device.datalogger_pn')"
          ></el-table-column>
          <el-table-column
            prop="devaddr"
            min-width="130px;"
            :show-overflow-tooltip="true"
            :label="$t('device.device_address')"
          ></el-table-column>
          <el-table-column
            min-width="140px;"
            :show-overflow-tooltip="true"
            :label="$t('device.coll_alias')"
          >
            <template slot-scope="scope">
              <span :title="scope.row.collalias||'--'">{{scope.row.collalias||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="120px;"
            :show-overflow-tooltip="true"
            :label="$t('device.User_belong')"
          >
            <template slot-scope="scope">
              <span :title="scope.row.usr||'--'">{{scope.row.usr||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="115px;"
            :show-overflow-tooltip="true"
            :label="$t('device.device_model')"
          >
            <template slot-scope="scope">
              <span :title="scope.row.devtype||'--'">{{scope.row.devtype||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" :label="this.$t('device.Operation')" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation"
                :title="$t('device.edit')"
                @click="editDevice(scope.row)"
              >
                <i class="iconfont icon-edit1"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('device.debug')"
                @click="debugDevice(scope.row)"
              >
                <i class="iconfont icon-tiaoshi"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('device.control')"
                @click="controlDevice(scope.row)"
              >
                <i class="iconfont icon-maintain"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('device.upgrade')"
                @click="upgradeDevice(scope.row)"
              >
                <i class="iconfont icon-upgrade"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('device.delete')"
                @click="deleteDevice(scope.row)"
              >
                <i class="iconfont icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
          <div v-show="emptyText" slot="empty">
            <img src="@/assets/img/empty_text.png" />
            <div style="line-height: 32px">{{$t('account.nodata')}}</div>
          </div>
        </el-table>
      </div>
      <div class="tablebottom">
        <el-pagination
          class="pagination"
          v-show="paginationControl"
          background
          @size-change="getDeviceList(true)"
          @current-change="()=>getDeviceList()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10,15,20,30,50]"
          :page-size.sync="pagination.pagesize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
      <!-- 编辑设备 -->
      <device-dialog
        :title="$t('device.modify_alias')"
        :visible.sync="editDeviceVisible"
        v-if="editDeviceVisible"
      >
        <div slot="content">
          <el-form class="grid">
            <el-form-item :label="$t('device.serial_number')" prop="sn" size="small">
              <el-input v-model="formEdit.sn" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.device_alias')" prop="devalias" size="small">
              <el-input v-model="formEdit.devalias" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <!-- <button
            class="button-hollow"
            @click="editDeviceVisible = false"
          >{{$t('device.cancel')}}</button>-->
          <button class="button-solid" @click="submitEditDevice">{{$t('device.confirm')}}</button>
        </div>
      </device-dialog>
      <!-- 逆变器调试 -->
      <device-dialog
        :title="$t('device.debug')"
        :visible.sync="debugDeviceVisible"
        v-if="debugDeviceVisible"
      >
        <div slot="content">
          <el-form class="grid">
            <el-form-item :label="$t('device.Device_pn')" size="small">
              <el-input v-model="device.pn" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.Instruction')" size="small">
              <el-input
                v-model="devDebug.cmd"
                :placeholder="$t('device.such_as')"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.return_content')" size="small">
              <el-input readonly v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <button class="button-hollow" @click="qingkong()">{{$t('device.clear_data')}}</button>
          <button
            class="button-solid"
            type="primary"
            @click="submitDebugDevice()"
          >{{$t('device.send')}}</button>
        </div>
      </device-dialog>
      <!-- 控制项 -->
      <device-dialog
        :title="$t('device.control')"
        :width="'900px'"
         style="padding: 0 35px 36px;"
        v-if="controlDeviceVisible"
        :visible.sync="controlDeviceVisible"
      >
        <div class="control" slot="content">
          <div v-if="tableDataBse.length">
            <div class="tableTitle">{{$t('createPlant.basic_settings')}}</div>
            <el-table
              :data="tableDataBse"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataStd.length">
            <div class="tableTitle">{{$t('createPlant.Standard_setting')}}</div>
            <el-table
              :data="tableDataStd"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataSvs.length">
            <div class="tableTitle">{{$t('createPlant.System_settings')}}</div>
            <el-table
              :data="tableDataSvs"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataPvs.length">
            <div class="tableTitle">{{$t('createPlant.Solar_settings')}}</div>
            <el-table
              :data="tableDataPvs"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataGrd.length">
            <div class="tableTitle">{{$t('createPlant.Grid_settings')}}</div>
            <el-table
              :data="tableDataGrd"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataBat.length">
            <div class="tableTitle">{{$t('createPlant.Battery_settings')}}</div>
            <el-table
              :data="tableDataBat"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataCts.length">
            <div class="tableTitle">{{$t('createPlant.Control_settings')}}</div>
            <el-table
              :data="tableDataCts"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataLos.length">
            <div class="tableTitle">{{$t('createPlant.Load_setting')}}</div>
            <el-table
              :data="tableDataLos"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataBas.length">
            <div class="tableTitle">{{$t('createPlant.Basic_setting')}}</div>
            <el-table
              :data="tableDataBas"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length" popper-class="select-search-recharge">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-shuaxin"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataAdv.length">
            <div class="tableTitle">{{$t('createPlant.Advanced_setting')}}</div>
            <el-table
              :data="tableDataAdv"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length" popper-class="select-search-recharge">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-shuaxin"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataElse.length">
            <div class="tableTitle">{{$t('createPlant.other_settings')}}</div>
            <el-table
              :data="tableDataElse"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 无数据 -->
          <div v-if="noDataControl">
            <el-table
              height="50vh"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column :label="$t('device.Field_Name')"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px"></el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')"></el-table-column>
              <el-table-column :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')"></el-table-column>
            </el-table>
          </div>
        </div>
      </device-dialog>
      <!-- 固件升级 -->
      <device-dialog
        v-if="upgradeDeviceVisible"
        :title="$t('device.device_upgrade')"
        :visible.sync="upgradeDeviceVisible"
        width="580px"
      >
        <div slot="content">
          <el-form class="grid upload-container">
            <el-form-item :label="$t('device.select_firmware')" size="small">
              <el-select v-model="searchrecharge.firmware" @change="voltageArr($event)" :placeholder="$t('device.select_file')">
                <el-option
                  v-for="item in rechargelist"
                  :key="item.value"
                  :label="item.firmware"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.firmware_type')" size="small">
              <el-select
                v-model="searchrecharge.firmwaretype"
                :placeholder="$t('device.select_type')"
              >
                <el-option
                  v-for="item in firmwaretypelist"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.upgrade_brate')" size="small">
              <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')">
                <el-option
                  v-for="item in bratelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" ">
              <div class="processstatueEquipment" v-show="progressUp">{{$t('firmware.upgrading')}}</div>
              <div
                class="processstatueEquipment"
                v-show="progerssComplete"
              >{{$t('firmware.updateCompleted')}}</div>
              <div class="upload-contents">
                <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                  <i class="iconfont icon-shangchuan"></i>
                  {{$t('device.Upload')}}
                </button>
                <div class="upload-tip">{{$t('firmware.limit0')}}</div>
              </div>
              <div class="progressShowEquipment" v-show="progressUp">
                <div class="progressName">
                  <i class="iconfont icon-fujian"></i>
                  {{firmwareName}}
                </div>
                <div class="progressCancel" @click="upgradeCancel">
                  <i class="iconfont icon-delete"></i>
                </div>
              </div>
              <div class="processDataEquipment" v-show="progressUp">
                <el-progress :format="progressText" :percentage="progress" :stroke-width="10"></el-progress>
                <div class="processBig">{{uploadNowSize}}M / {{uploadTotalSize}}M</div>
              </div>
              <input
                type="file"
                class="upload-input"
                ref="fileUploader"
                accept="application/octet-stream"
                @change="uploadfile($event)"
              />
              <div class="progerssCompleteEquipment" v-show="progerssComplete">
                <div class="progressName">
                  <i class="iconfont icon-fujian"></i>
                  {{firmwareName}}
                </div>
                <div class="progressCancel"></div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <!-- <button class="button-hollow" @click="upgradeDeviceVisible = false">{{$t('device.cancel')}}</button> -->
          <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button>
        </div>
      </device-dialog>
      <!-- 删除设备 去掉弹框的heard不加title=""和footer noFooter -->
      <device-dialog
        :visible.sync="deleteDeviceVisible"
        v-if="deleteDeviceVisible"
        width="30vw"
        noFooter
      >
        <div class="content_tishi" slot="content">
          <div class="tital">
            <i class="iconfont icon-gantanhao"></i>
            <span class="contentdelete">{{$t('device.confirm_deldte')}}</span>
          </div>
          <div class="disabledescr">{{$t('account.notRecovered')}}</div>
          <!-- </div> -->
          <div class="deletfotter">
            <button class="button-solid" @click="submitDeleteDevice">{{$t('device.confirm')}}</button>
            <button
              class="button-hollow"
              @click="deleteDeviceVisible = false"
            >{{$t('device.cancel')}}</button>
          </div>
        </div>
      </device-dialog>
      <!--编辑设备控制权限弹框 -->
      <device-dialog
        :visible.sync="editDeviceControlVisible"
        :title="$t('device.edit_control')"
        v-if="editDeviceControlVisible"
        width="1125px"
        noFooter
      >
        <div slot="content">
          <div class="editControl">
            <div class="searchprotocol">
              <div class="searchName">{{$t('device.Equipment_agreement')}} :</div>
              <el-select
                v-model="searchProtocol"
                :placeholder="$t('device.Equipment_agreement')"
                popper-class="select-search"
                @change="getProtocolData"
              >
                <el-option
                  v-for="item in protocolAllData"
                  :key="item.desc"
                  :value="item.devcode"
                  :label="item.desc"
                ></el-option>
              </el-select>
            </div>
            <div class="personProtocol">
              <div class="contentLeft">{{$t('device.person_cansee')}}</div>
              <div class="contentRight">
                <div class="top">
                  <el-checkbox
                    v-model="CheckAllPerson"
                    @change="checkAllPerson"
                  >{{$t('device.Check_all')}}</el-checkbox>
                  <el-checkbox
                    v-model="CheckNoPerson"
                    @change="checkNoPerson"
                  >{{$t('device.Cancel_all')}}</el-checkbox>
                </div>
                <div class="protoclContents" v-if="protocolDataShow">
                  <el-checkbox-group v-model="checkPersonData">
                    <el-checkbox
                      v-for="item in checkStatueData"
                      :label="item.name"
                      :title="item.name"
                      :key="item.id"
                      class="checkboxUnit"
                      @change="protoclPersonChange(item)"
                    >{{item.name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="noData" v-else>{{$t('message.nodata')}}</div>
              </div>
            </div>
            <div class="adminProtocol">
              <div class="contentLeft">{{$t('device.administrator_cansee')}}</div>
              <div class="contentRight">
                <div class="top">
                  <el-checkbox
                    v-model="CheckAllAdmin"
                    @change="checkAllAdmin"
                  >{{$t('device.Check_all')}}</el-checkbox>
                  <el-checkbox
                    v-model="CheckNoAdmin"
                    @change="checkNoAdmin"
                  >{{$t('device.Cancel_all')}}</el-checkbox>
                </div>
                <div class="protoclContents" v-if="protocolDataShow">
                  <el-checkbox-group v-model="checkAdminData">
                    <el-checkbox
                      v-for="item in checkStatueData"
                      :label="item.name"
                      :title="item.name"
                      :key="item.id"
                      class="checkboxUnit"
                      @change="protoclAdminChange(item)"
                    >{{item.name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="noData" v-else>{{$t('message.nodata')}}</div>
              </div>
            </div>
          </div>
        </div>
      </device-dialog>
    </div>
  </div>
</template>
<script>
import deviceDialog from "@/components/dialog";
import { mapState } from "vuex";
// import config from '@/assets/js/config';
export default {
  components: {
    deviceDialog
  },
  data() {
    return {
      noDataControl: false,
      emptyText: false,
      protocolIdBox: null, //控制项全部ID
      protocolNameBox: null, //控制项全部名称
      vcodeBox: "", //厂家编号的盒子
      CheckAllPerson: false,
      CheckAllAdmin: false,
      CheckNoPerson: false,
      CheckNoAdmin: false,
      checkAdminData: null,
      checkPersonData: null,
      checkStatueData: null,
      protocolDataShow: true,
      protocolAllData: null,
      searchProtocol: "",
      paginationControl: false,
      statueNum: {
        normal: "100",
        offline: "100",
        warning: "100",
        fault: "100",
        standby: "100"
      },
      progressUp: false,
      progress: 0,
      search: {
        status: "",
        usr: "",
        brand: "",
        pn: "",
        search: ""
      },
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrechargeContents: "", //选择固件时里面的内容
      searchrecharge: {
        firmware: "",
        firmwaretype: "0",
        brate: "0"
      },
      deviceStatus: {
        normalCount: {
          num: 0,
          label: this.$t("statistic.normal"),
          class: "status-normal"
        },
        offCount: {
          num: 0,
          label: this.$t("statistic.offline"),
          class: "status-offline"
        },
        faultCount: {
          num: 0,
          label: this.$t("statistic.fault"),
          class: "status-fault"
        },
        standby: {
          num: 0,
          label: this.$t("statistic.standby"),
          class: "status-standby"
        },
        warningCount: {
          num: 0,
          label: this.$t("statistic.warning"),
          class: "status-warning"
        }
      },
      dataparams: "",
      rechargelist: [],
      firmwaretypelist: [
        {
          //通用固件
          id:11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id:12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id:13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id:14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
        {
          //BMS固件
          id:15,
          label: this.$t("device.control_firmware_bms"),
          value: "4"
        },
        {
          //SlavMCU固件
          id:16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5"
        }
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0"
        },
        {
          label: 1200,
          value: "1200"
        },
        {
          label: 2400,
          value: "2400"
        },
        {
          label: 4800,
          value: "4800"
        },
        {
          label: 9600,
          value: "9600"
        },
        {
          label: 19200,
          value: "19200"
        },
        {
          label: 38400,
          value: "38400"
        },
        {
          label: 57600,
          value: "57600"
        },
        {
          label: 115200,
          value: "115200"
        }
      ],
      loadingDevice: false,
      // isLoading: false,
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      deviceList: [],
      tableDataBse:[],
      tableDataStd:[],
      tableDataSvs:[],
      tableDataPvs:[],
      tableDataGrd:[],
      tableDataBat:[],
      tableDataCts:[],
      tableDataLos:[],
      tableDataBas:[],
      tableDataAdv:[],
      tableDataElse:[],
      controlinter: [],
      controlvalue: "",
      editDeviceVisible: false,
      editDeviceInfo: null,
      debugDeviceVisible: false,
      debugDeviceId: null,
      upgradeDeviceVisible: false,
      upgradeDeviceterId: null,
      deleteDeviceVisible: false,
      deletingDeviceInfo: null,
      controlDeviceVisible: false,
      editDeviceControlVisible: false, //控制权限弹框
      formEdit: {
        sn: "",
        pn: "",
        devaddr: "",
        devcode: "",
        alias: ""
      },
      device: {
        pn: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: ""
    };
  },
  watch: {
    deleteDeviceVisible(val) {
      if (!val) this.deletingDeviceInfo = null;
    },
    upgradeDeviceVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    }
  },
  created() {
    // 解析通过路由传入的搜索条件
    let status = "";
    Object.entries(this.$filter.deviceStatus).forEach(item => {
      if (
        item[1].name == this.$route.query.status ||
        item[1].label == this.$route.query.status
      ) {
        status = item[0];
      }
    });
    this.search.status = status;

    this.getDeviceList();
    this.queryDeviceStatus();
    this.getVcodeData();
  },
    computed: {
            ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  methods: {
    progressText(progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    // 查询设备列表
    getDeviceList(reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        ...this.search,
        devtype: 2304,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize
      };
      this.loadingDevice = true;
      this.$request.get("webQueryDeviceEs", param).then(res => {
        if (res.err === 0) {
          this.deviceList = res.dat.device;
          this.pagination.total = res.dat.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.deviceList = [];
          this.pagination.total = 0;
        }
        this.loadingDevice = false;
      });
    },
    // 获取设备状态
    queryDeviceStatus() {
      this.$request
        .get("webQueryDeviceStatusViewEs", { devtype: 2304 })
        .then(res => {
          if (res.err == 0) {
            for (let key in this.deviceStatus) {
              this.deviceStatus[key].num = res.dat[key];
            }
          }
        });
    },
    // 点击进入设备
    enterDevice(info) {
      if (!info.uid) {
        this.$message.error(this.$t(`device.noAuth`));
        return;
      }
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            // console.log('管理员进入设备', res.dat)
            let routeUrl = this.$router.resolve({
              path: "/general/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
                devcode: info.devcode,
                pn: info.pn,
                devaddr: info.devaddr,
                sn: info.sn
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 编辑设备
    editDevice(info) {
      this.editDeviceVisible = true;
      this.formEdit = { ...info };
    },
    // 确定修改逆变器
    submitEditDevice() {
      let param = {
        pn: this.formEdit.pn,
        sn: this.formEdit.sn,
        devaddr: this.formEdit.devaddr,
        devcode: this.formEdit.devcode,
        alias: this.formEdit.devalias
      };
      this.$request.get("editDeviceInfo", param).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t("device.modifySuc"));
          debugger;
          this.formEdit = {};
          this.getDeviceList();
          this.editDeviceVisible = false;
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    //查询此管理员的厂家编号vcode,用于控制权限
    getVcodeData() {
      this.$request.get("queryVendorCode").then(res => {
        if (res.err == 0) {
          this.vcodeBox = res.dat.vendorcode[0].code;
        }
      });
    },
    //打开控制权限按钮
    editDeviceControl() {
      this.editDeviceControlVisible = true;
      this.CheckAllPerson = false;
      this.CheckNoPerson = false;
      this.CheckAllAdmin = false;
      this.CheckNoAdmin = false;
      this.$request.get("queryDeviceDevcodes").then(res => {
        if (res.err == 0) {
          res.dat.devcode.forEach(item => {
            item.desc = item.devcode + " -" + item.desc;
          });
          this.protocolAllData = res.dat.devcode;
          this.searchProtocol = this.protocolAllData[0].devcode;
          this.getProtocolData();
        } else {
          this.checkStatueData = [];
          this.protocolDataShow = false;
          // this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    //通过协议查询协议里面的控制项
    getProtocolData() {
      this.protocolDataShow = true;
      this.$request
        .get("queryDeviceCtrlFieldForDist", {
          vcode: this.vcodeBox,
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          i18n: this.$lang.currentLang
        })
        .then(res => {
          if (res.err == 0) {
            this.checkStatueData = res.dat.field;
            this.protocolIdBox = [];
            this.protocolNameBox = [];
            let personProtocolBox = [],
              adminProtocolBox = [];
            res.dat.field.forEach(item => {
              if (item.visable) {
                personProtocolBox.push(item.name);
              }
              if (item.distributorPermissionFlag) {
                adminProtocolBox.push(item.name);
              }
              this.protocolIdBox.push(item.id);
              this.protocolNameBox.push(item.name);
            });
            this.checkPersonData = personProtocolBox;
            this.checkAdminData = adminProtocolBox;
          } else {
            this.checkStatueData = [];
            this.protocolDataShow = false;
          }
        });
    },
    //电站业主全部勾选
    checkAllPerson() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          visable: true
        })
        .then(res => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckAllPerson = true;
            this.CheckNoPerson = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //电站业主全部取消
    checkNoPerson() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          visable: false
        })
        .then(res => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckAllPerson = false;
            this.CheckNoPerson = true;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //管理员全部勾选
    checkAllAdmin() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          distributorPermissionFlag: true
        })
        .then(res => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckNoAdmin = false;
            this.CheckAllAdmin = true;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //管理员全部取消
    checkNoAdmin() {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          ids: this.protocolIdBox.toString(),
          vcode: this.vcodeBox,
          distributorPermissionFlag: false
        })
        .then(res => {
          if (res.err == 0) {
            this.getProtocolData();
            this.CheckNoAdmin = true;
            this.CheckAllAdmin = false;
          } else {
            this.$message.error(res.err);
          }
        });
    },
    //管理员点击单个的控制权限
    protoclAdminChange(val) {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          id: val.id,
          vcode: this.vcodeBox,
          distributorPermissionFlag: !val.distributorPermissionFlag
        })
        .then(res => {
          if (res.err == 0) {
            this.CheckAllAdmin = false;
            this.CheckNoAdmin = false;
            this.getProtocolData();
            this.isIndeterminateAdmin = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //电站业主点击单个的控制权限
    protoclPersonChange(val) {
      this.$request
        .get("editDeviceCtrlFieldForDist", {
          devcode: this.searchProtocol || this.protocolAllData[0].devcode,
          id: val.id,
          vcode: this.vcodeBox,
          visable: !val.visable
        })
        .then(res => {
          if (res.err == 0) {
            this.CheckNoPerson = false;
            this.CheckAllPerson = false;
            this.getProtocolData();
            this.isIndeterminatePerson = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 调试设备
    debugDevice(info) {
      this.devDebug.cmd = null;
      this.debugReturn = null;
      this.debugDeviceVisible = true;
      // this.debugDeviceId = id;
      this.$request
        .get("queryDeviceInfo", {
          device:
            info.pn + "," + info.devcode + "," + info.devaddr + "," + info.sn
        })
        .then(res => {
          if (res.err === 0) {
            // this.debugDeviceVisible = true,
            // this.getDeviceList();
            this.device = res.dat[0];
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 调试清空
    qingkong() {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 发送指令
    submitDebugDevice() {
      if (this.device.status == "1") {
        this.$message.error(this.$t("device.Debugfail"));
      } else {
        this.debugReturn = this.$t("device.instruction_response");
        let param = {
          pn: this.device.pn,
          devaddr: this.device.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.debug_suc"));
            this.debugReturn = res.dat.dat;
            // this.debugDeviceVisible = false;
            // this.getDeviceList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 控制项
    controlDevice(info) {
      this.controlDeviceVisible = true;
      this.noDataControl = false;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      i18n: this.$lang.currentLang,
            role:1,
        accountType:this.$store.state.user.role == 0? 3 : this.$store.state.user.role,
        userId:this.$store.state.user.uidExtra
      };
      this.controlparams = info;
      let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceCtrlStrategy" : "queryDeviceCtrlField";
      this.$request[this.method](url, param).then(res => {
        if (res.err == 0) {
          let tableData = res.dat.field;
          let arr1 = [],arr2 = [],arr3 = [],arr4 = [],arr5 = [],arr6 = [],arr7 = [],arr8 = [],arr9 = [],arr10=[],arr11=[];
          tableData.forEach(field => {
            field.controlinter = [];
            if (field.item) {
              field.item.forEach(item => {
                field.controlinter.push({
                  label: item.val,
                  value: item.key
                });
              });
              //默认显示第一项
              // field.controlvalue = field.item.length ? field.controlinter[0].value: "";
              //不显示任由选择
              field.controlvalue = "";
            }
            var s = field.id;
            if (s.startsWith("bse_")) {
              arr1.push(field)
            } else if (s.startsWith("std_")) {
              arr2.push(field)
            } else if (s.startsWith("sys_")) {
              arr3.push(field)
            } else if (s.startsWith("pvs_")) {
              arr4.push(field)
            } else if (s.startsWith("grd_")) {
              arr5.push(field)
            } else if (s.startsWith("bat_")) {
              arr6.push(field)
            } else if (s.startsWith("cts_")) {
              arr7.push(field)
            } else if (s.startsWith("los_")) {
              arr8.push(field)
            } else if (s.startsWith("bas_")) {
              arr10.push(field)
            } else if (s.startsWith("adv_")) {
              arr11.push(field)
            } else {
              arr9.push(field)
            }
            // this.huoquInverter(field)
          });
          this.tableDataAdv = arr11;
          this.tableDataBas = arr10;
          this.tableDataElse = arr9;
          this.tableDataLos = arr8;
          this.tableDataCts = arr7;
          this.tableDataBat = arr6;
          this.tableDataGrd = arr5;
          this.tableDataPvs = arr4;
          this.tableDataSvs = arr3;
          this.tableDataStd = arr2;
          this.tableDataBse = arr1;
        }else{
          this.noDataControl = true;
          this.tableDataAdv = [];
          this.tableDataBas = [];
          this.tableDataElse = [];
          this.tableDataLos = [];
          this.tableDataCts = [];
          this.tableDataBat = [];
          this.tableDataGrd = [];
          this.tableDataPvs = [];
          this.tableDataSvs = [];
          this.tableDataStd = [];
          this.tableDataBse = [];
        }
      });
    },
    // 控制项获取当前值
    huoquInverter(info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        id: info.id,
        i18n: this.$lang.currentLang
      };
      this.$set(info,'isLoading',true)
      // info.isLoading = true;
      this.$request.get("queryDeviceCtrlValue", param).then(res => {
        if (res.err == 0) {
          // info.dangqianzhi = res.dat.val;
          this.$set(info,'dangqianzhi',res.dat.val)
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.isLoading = false;
        this.$set(info,'isLoading',false)
      }).catch(() => {
          this.$set(info, "isLoading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
    },
    // 下发指令
    xiafaInverter(info) {
      if (!info.controlvalue) {
        this.$message.error(this.$t("device.Send_Input"));
      } else {
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          val: info.controlvalue,
          i18n: this.$lang.currentLang
        };
        this.$set(info,'Loading',true)
        // info.Loading = true;
        this.$request.get("ctrlDevice", param).then(res => {
        // this.$request.get("ctrlDevice", param).then(res => {
          if (res.err == 0) {
            if (this.controlparams.devcode == 2352) {
              var medium = res.dat.dat.substring(27, 29);
              if (medium == "31") {
                this.$message.success(this.$t("device.Send_suc"));
              } else {
                this.$message.error(this.$t("device.Send_fail"));
              }
            } else {
              this.$message.success(this.$t("device.Send_suc"));
            }
          } else {
             if (this.controlparams.devcode == 2376) {
              if(res.desc.match(/\(([^)]*)\)/)){
                this.$message.error(res.desc.match(/\(([^)]*)\)/)[1]);
              }else{
                const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
                this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
              }
            } else {
              const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
              this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
            }
            // this.$message.error(this.$t(`errCode.${res.err}`));
          }
          // info.Loading = false;
          this.$set(info,'Loading',false)
        }).catch(() => {
          this.$set(info, "Loading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
      }
    },
    voltageArr(item){
     this.rechargelist.forEach(element => {
       if(element.id == item){
         this.searchrechargeContents = element
       }
     });
    },
    // 设备固件升级
    upgradeDevice(info) {
      this.queryFirmware();
      this.dataparams = info;
      this.upgradeDeviceVisible = true;
      this.progerssComplete = false;
    },
    // 查询固件列表
    queryFirmware() {
      this.searchrecharge.firmware =null;
      this.rechargelist = [];
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { pagesize: 50 }).then(res => {
        if (res.code == 0) {
          res.data.items.forEach(item => {
            this.rechargelist.push({
              id: item.id,
              firmware: item.firmware,
              size: item.size
            });
          });
        }
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile(event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("device.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex"&& suffix !== "S19") {
        this.$message.error(this.$t("device.error1"));
        return;
      }
      this.$request.uploadfileAxios(file).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("device.uploadSuccess"));
          // this.upgradeDeviceVisible = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("device.error1"));
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
        }
        this.queryFirmware();
        // this.upgradeDeviceVisible = false;
      });
    },
    // 确认固件升级
    submitUpgradeDevice() {
      this.progress = 0;
      if (!this.searchrecharge.firmware) {
        this.$message.error(this.$t("device.file_fist"));
      } else if (this.dataparams.status == "1") {
        this.$message.error(this.$t("device.updatefail"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          pn: this.dataparams.pn,
          devaddr: this.dataparams.devaddr,
          devcode: this.dataparams.devcode,
          sn: this.dataparams.sn,
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/device/upgrade/firmwareUpgradeDevice", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              this.$message.success(this.$t("device.Upgrading"));
              // this.$message.success(this.$t("device.update_suc"));
              this.queryProgress();
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
            }
            // this.upgradeDeviceVisible = false;
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
          }
        });
      }
    },
    // 查询升级进度
    queryProgress() {
      this.progressUp = true;
      this.progerssComplete = false;
      let params = {
        pn: this.dataparams.pn,
        devaddr: this.dataparams.devaddr,
        devcode: this.dataparams.devcode,
        sn: this.dataparams.sn,
        key: this.keyProgress
      };
       // 如果已存在定时器，先清除
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                // this.progressText = progress + '%'
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  clearInterval(this.interval);
                  this.interval = null;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.$message.success(this.$t("device.Update_Completed"));
                  setTimeout(() => {
                    this.upgradeDeviceVisible = false;
                  }, 3000);
                  return;
                }
              } else if (res.data.status == 1) {
                this.$message.error(this.$t("firmware.upgrade_quit1"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 2) {
                this.$message.error(this.$t("firmware.upgrade_quit2"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 3) {
                this.$message.error(this.$t("firmware.upgrade_quit3"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 4) {
                this.$message.error(this.$t("firmware.upgrade_quit4"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 5) {
                this.$message.error(this.$t("firmware.upgrade_quit5"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              }
            } else {
              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              clearInterval(this.interval);
              this.interval = null;
            }
          });
      }, 2000);
    },
    //取消升级
    upgradeCancel() {
      this.$request.putUPG("/upg/api/auth/web/shineDess/device/upgrade/deviceCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
    },
    deleteDevice(info) {
      this.deletingDeviceInfo = {
        pn: info.pn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        sn: info.sn
      };
      this.deleteDeviceVisible = true;
    },
    // 确定删除逆变器
    submitDeleteDevice() {
      this.$request
        .get("delDeviceFromPlant", this.deletingDeviceInfo)
        .then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.deleteSuc"));
            this.deleteDeviceVisible = false;
            this.getDeviceList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");
.device {
  background-color: #fff;
  margin: 10px;
  // margin: 24px 24px 50px 24px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  .devicetop {
    // display: flex;
    // flex-direction: row;
    // justify-content: space-between;
    padding: 15px 24px 0;
    align-self: flex-end;
    // .devicename {
    //   font-size: 16px;
    //   font-weight: bold;
    //   color: #333;
    //   letter-spacing: 1.5px;
    // }
  }
  .search {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .button-create {
      float: right;
    }
  }
  .sections {
    margin: 0 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .table {
      flex: 1;
      overflow: auto;
      /deep/.el-icon-loading{
            font-size: 28px;
        }
    }
    .tablebottom {
      align-self: flex-end;
      // text-align: center;
      margin-bottom: 10px;
    }

    .current-value {
      display: flex;
      .el-input {
        flex: 1;
        margin-right: 3px;
      }
      .submit-control {
        i {
          font-size: 18px;
        }
        padding: 5px 12px;
      }
    }
    .control-value {
      .submit-control {
        padding: 6px 20px;
        i {
          font-size: 18px;
        }
      }
    }
    .control {
      height: 50vh;
      .el-table{
        margin-bottom: 20px;
        /deep/ tr td:first-child .cell {
          text-align: left;
        }
      }
      .tableTitle {
        margin-bottom: 5px;
        // padding: 20px 0 5px;
        font-size: 16px;
        color: #595959;
        font-weight: bold;
      }
    }
  }
  .active {
    color: #26ae3c;
  }
  .inactive {
    color: #c9c9c9;
  }
  .upload-input {
    display: none;
  }
  .contentdelete {
    font-size: 20px;
    font-weight: 600;
  }
  .deletfotter {
    margin-top: 50px;
    .button-hollow {
      width: 100px;
      height: 40px;
      margin-right: 40px;
    }
    .button-solid {
      width: 100px;
      height: 35px;
    }
  }
  .status-container {
    display: flex;
    align-items: center;
    .status {
      border-radius: 25px;
      box-shadow: 0px -1px 2.5px #7f7f7f;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 10px;
      padding: 0px 20px;
      height: 32px;
      line-height: 32px;
      background-color: #fff;
      // border: 1px solid #000;
      border-radius: 18px;
      box-shadow: inset 0px 0px 5px 1px #ccc;
      &-num {
        color: #333;
        font-size: 14px;
      }
      &-label {
        color: #333;
        font-size: 14px;
      }
      &-icon {
        width: 10px;
        height: 10px;
        margin-right: 3px;
      }
    }
  }
  //控制权限里面的样式
  .editControl {
    margin-top: -20px;
    margin-bottom: -2px;
    display: flex;
    flex: 1;
    flex-direction: column;
    .searchprotocol {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 15px;
      .searchName {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        min-width: 100px;
      }
      .el-select {
        margin-left: 10px;
        width: 500px;
        // overflow: auto;
      }
    }
    .personProtocol,
    .adminProtocol {
      display: flex;
      flex-direction: row;
      min-height: 180px;
      border: 1px solid #d9d9d9;
      .contentLeft {
        margin: auto;
        font-family: "Times New Roman", "Microsoft YaHei";
        font-size: 16px;
        letter-spacing: 1.5px;
        height: 100%;
        width: 110px;
        padding: 10px;
      }
      .contentRight {
        flex: 1;
        border-left: 1px solid #d9d9d9;
        display: flex;
        flex-direction: column;
        .top {
          height: 25px;
          line-height: 25px;
          text-align: center;
          border-bottom: 1px solid #d9d9d9;
          /deep/ .el-checkbox__label {
            width: 50px;
          }
        }
        .noData {
          margin: 40px auto;
          font-size: 14px;
          color: #909399;
        }
        .protoclContents {
          flex: 1;
          max-height: 320px;
          overflow: auto;
          .checkboxUnit {
            // font-family: "微软雅黑";
            padding-left: 6px;
            margin: 0;
            border-right: 0.5px solid #eee;
            /deep/ .el-checkbox__label {
              font-size: 14px !important;
              padding-left: 5px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 136px !important;
              padding-top: 5px;
            }
          }
        }
        /deep/ .el-checkbox__inner {
          width: 14px;
          height: 14px;
        }
        /deep/ .el-checkbox__inner::after {
          top: 1px;
          left: 4px;
        }
      }
    }
    .adminProtocol {
      margin-top: 15px;
    }
  }
}
</style>
